import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'ui';

const CustomBadgeModal = ({ shown, toggleModal, toggleUploadModal }) => {
  return (
    <Modal
      shown={shown}
      canClickAway={false}
      className="Modal-container CustomBadgeModal bg-gray-lightest"
      onDismiss={toggleModal}
      enableFloatingDismiss
    >
      <Modal.Content>
        <h1 className="LessonVersionModal-title pb-32 ff-ss fw-n c-brand-gray-darkest">
          {t('certifications.custom_badge_modal.title')}
        </h1>
        <div className="d-f fd-c fz-16">
          <span className="ff-ss fw-b pb-24">
            {t('certifications.custom_badge_modal.subtitle')}
          </span>
          <span className="ff-ss c-brand-gray-darker">
            {t('certifications.custom_badge_modal.image_size_description')}
          </span>
          <span className="ff-ss c-brand-gray-darker pb-40">
            {t('certifications.custom_badge_modal.design_description')}
          </span>
          <Button className="w-125 mb-8" onClick={toggleUploadModal} primary>
            {t('certifications.custom_badge_modal.upload')}
          </Button>
          <span className="ff-ss c-brand-gray-darker fz-14">
            {t(
              'certifications.custom_badge_modal.image_types_recommendation_description',
            )}
          </span>
          <span className="ff-ss c-brand-gray-darker fz-14">
            {t(
              'certifications.custom_badge_modal.image_size_recommendation_description',
            )}
          </span>
        </div>
      </Modal.Content>
    </Modal>
  );
};

CustomBadgeModal.propTypes = {
  shown: PropTypes.bool,
  toggleModal: PropTypes.func,
  toggleUploadModal: PropTypes.func,
};

export default CustomBadgeModal;
